import {
  ArrowDown,
  DollarSign,
  FileText,
  Settings,
  TrendingDown,
  TrendingUp,
  Zap,
} from 'lucide-react'
import { Button } from '@/shared/components/ui/button'
import type { QuickAction } from '../types/ai-assistant.types'

interface AIQuickActionsProps {
  actions: QuickAction[]
  onActionClick: (actionId: string) => void
}

const iconMap = {
  TrendingDown,
  DollarSign,
  ArrowDown,
  TrendingUp,
  Settings,
  FileText,
  Zap,
}

export function AIQuickActions({
  actions,
  onActionClick,
}: AIQuickActionsProps) {
  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 gap-3'>
      {actions.map(action => {
        const IconComponent =
          iconMap[action.icon as keyof typeof iconMap] || Zap

        return (
          <Button
            key={action.id}
            variant='outline'
            className='h-auto p-3 text-left justify-start hover:bg-blue-50 hover:border-blue-300 transition-colors'
            onClick={() => onActionClick(action.id)}
          >
            <div className='flex items-center gap-3 w-full'>
              <div className='w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0'>
                <IconComponent className='h-4 w-4 text-blue-600' />
              </div>
              <div className='flex-1 min-w-0'>
                <div className='font-medium text-sm'>{action.label}</div>
                <div className='text-xs text-muted-foreground mt-1 line-clamp-2'>
                  {action.prompt}
                </div>
              </div>
            </div>
          </Button>
        )
      })}
    </div>
  )
}
